interface PrivacyConsentProvidedOrBypassedProps {
  privacyChkBox: boolean;
  privacyChkBoxValue: boolean;
}

export const privacyConsentProvidedOrBypasses = (
  params: PrivacyConsentProvidedOrBypassedProps,
) => (params.privacyChkBox ? params.privacyChkBoxValue : true);
